// Copyright 2022 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import { CAMiV64GuidanceCatalog } from "catalogs/GuidanceCatalog/CAMiV64GuidanceCatalog";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class IndustrialReportWorkflowModuleCatalog {
    static ReportSelectionModule: IWorkflowModuleConfig = {
        name: "manageReport",
        modulePath: PLATFORM.moduleName("modules/workflows/ReportEx/ManageReport/ManageReportModule"),
        title: "Report Selection",
        moduleType: WorkflowModuleType.Report,
        isInadmissible: true,
        requireSignIn: true,
        requireClient: false,
        disableForWorkflowModes: [WorkflowModes.AcousticDesignCycle, WorkflowModes.AcousticDesignCycleLite],
        help: CAMiV64GuidanceCatalog.CAMiV64_DownloadReport,
    };
}
